import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Routes } from '../configs/api.router.config';

@Injectable()
export class GlobalService {
  constructor(private readonly http: HttpClient) {}

  public getGroup() {
    return this.http.get(Routes.getGroup, {});
  }
  public getDomains() {
    return this.http.get(Routes.getDomains, {});
  }

  public group(id: any) {
    return this.http.post(Routes.groupMessage({ id }), {});
  }
  public cat(id: any) {
    return this.http.post(Routes.catMessage({ id }), {});
  }

  public groupNews(id: any) {
    return this.http.post(Routes.groupNews({ id }), {});
  }
  public catNews(id: any) {
    return this.http.post(Routes.catNews({ id }), {});
  }
  public groupPromo(id: any) {
    return this.http.post(Routes.groupPromo({ id }), {});
  }
  public catSlide(id: any) {
    return this.http.post(Routes.catSlide({ id }), {});
  }
  public groupSlide(id: any) {
    return this.http.post(Routes.groupSlide({ id }), {});
  }
  public catPromo(id: any) {
    return this.http.post(Routes.catPromo({ id }), {});
  }
  public groupEvent(id: any) {
    return this.http.post(Routes.groupEvent({ id }), {});
  }
  public groupDocument(id: any) {
    return this.http.post(Routes.groupDocument({ id }), {});
  }
  public catEvent(id: any) {
    return this.http.post(Routes.catEvent({ id }), {});
  }
}
